import MicroModal from 'micromodal';
import { Component } from '../../../libs/gin-tonic/helpers/compiler';
import { getParentOrSelfWithClass } from '../../../libs/gin-tonic/helpers/dom/get-parent-or-self-with-class';

declare let gsap: any;
declare let Flip: any;
declare let Linear: any;

@Component({ className: 'js-team-modal' })
export class TeamComponent {
	private container = null;
	private newContainer;
	private modalId = 'modal-team';

	constructor(private element: HTMLElement) {
		gsap.registerPlugin(Flip);
		this.newContainer = this.element.querySelector(
			'.js-team-modal-img-container'
		);
		const triggers = Array.from(
			document.querySelectorAll('.js-team-modal-trigger')
		) as HTMLElement[];

		if (triggers && triggers.length > 0) {
			triggers.forEach((trigger) => {
				trigger.addEventListener('click', (e) => {
					e.preventDefault();
					MicroModal.show(this.modalId, {
						onShow: (modal) => this.open(modal, trigger),
						onClose: (modal) => this.close(modal),
						openClass: 'is-open',
						disableFocus: false,
						awaitOpenAnimation: true,
						awaitCloseAnimation: true,
					});
				});
			});
		}

		// add click event to closing elements as micromodal doesn't detect everything
		document
			.querySelector(`#${this.modalId}`)
			.querySelectorAll('[data-micromodal-close]')
			.forEach((element) => {
				element.addEventListener('click', (e) => {
					e.preventDefault();
					MicroModal.close(this.modalId);
				});
			});

		document
			.querySelector(`#${this.modalId}`)
			.querySelectorAll('[data-micromodal-overlay-close]')
			.forEach((element) => {
				element.addEventListener('click', (e) => {
					if (element === (e.target as HTMLElement)) {
						e.preventDefault();
						MicroModal.close(this.modalId);
					}
				});
			});
	}

	open(modal: HTMLElement, elem: HTMLElement) {
		const trigger = getParentOrSelfWithClass(elem, 'js-team-modal-trigger');
		// ----- set Values -----
		const nameEl = modal.querySelector('.js-team-modal-person-name');
		if (nameEl != null) {
			nameEl.textContent =
				trigger.querySelector('.js-team-person-name')?.textContent || '';
		}
		const diplomaEl = modal.querySelector('.js-team-modal-person-diploma');
		if (diplomaEl != null) {
			diplomaEl.textContent = trigger.getAttribute('data-team-diploma');
		}
		const positionEl = modal.querySelector('.js-team-modal-person-position');
		if (positionEl != null) {
			positionEl.textContent =
				trigger.querySelector('.js-team-person-position')?.textContent || '';
		}

		// linkedin
		const linkedinEl = modal.querySelector<HTMLLinkElement>(
			'.js-team-modal-person-linkedin'
		);
		if (linkedinEl != null) {
			const linkedinVal = trigger.getAttribute('data-team-linkedin') || '';
			linkedinEl.classList.toggle('is-hidden', linkedinVal == '');
			linkedinEl.href = linkedinVal;
		}

		// mail
		const mailEl = modal.querySelector<HTMLLinkElement>(
			'.js-team-modal-person-mail'
		);
		if (mailEl != null) {
			const mailVal = trigger.getAttribute('data-team-mail');
			const icon = mailEl.querySelector('.c-icon');
			mailEl.classList.toggle('is-hidden', mailVal == '');
			mailEl.innerHTML = '';
			mailEl.append(icon);
			mailEl.append(mailVal);
			mailEl.href = 'mailto:' + mailVal;
		}

		// animate img
		const img = trigger.querySelector('.js-team-person-img');

		if (img) {
			this.container = img.parentNode;
			const state = Flip.getState(img);
			this.newContainer.appendChild(img);

			Flip.from(state, {
				duration: 0.5,
				ease: Linear.easeInOut,
				scale: true,
				zIndex: 10,
				absolute: true,
				nested: true,
			});
		}

		// animate Values
		gsap.fromTo(
			modal.querySelector('.js-team-profile')?.children,
			{
				y: 50,
				opacity: 0,
			},
			{
				y: 0,
				opacity: 1,
				stagger: 0.1,
			}
		);
	}

	close(modal: HTMLElement) {
		// linkedin
		const linkedinEl = modal.querySelector<HTMLLinkElement>(
			'.js-team-modal-person-linkedin'
		);
		if (linkedinEl != null) {
			linkedinEl.classList.remove('is-hidden');
			linkedinEl.href = '';
		}

		// mail
		const mailEl = modal.querySelector<HTMLLinkElement>(
			'.js-team-modal-person-mail'
		);
		if (mailEl != null) {
			const icon = mailEl.querySelector('.c-icon');
			mailEl.classList.remove('is-hidden');
			mailEl.innerHTML = '';
			mailEl.href = '';
			mailEl.append(icon);
		}

		const img = this.newContainer.querySelector('.js-team-person-img');

		if (img) {
			const state = Flip.getState(img);
			this.container.appendChild(img);
			this.container = null;

			Flip.from(state, {
				duration: 0.5,
				ease: Linear.easeInOut,
				scale: true,
				zIndex: 10,
				absolute: true,
				nested: true,
			});
		}
	}
}
